import React from 'react';
import useMoveMutation from "../libs/MoveHandler";

const MailItem = ({avatar, sender, time, subject, text, unread, msg, onClick, onCheck }) => {

    const { moveHandle } = useMoveMutation();

    const avatarContent = msg?.first_letter
        ? <span className="avatar-letter"><span style={{backgroundColor: msg.color.backgroundColor,color: msg.color.color}}>{msg.first_letter}</span></span>
        : <img src={avatar} alt="avatar" />

    const unreadClass = unread ? "mail-item unread" : "mail-item";

    return (
        <li className={unreadClass}>
            <div className="pe-2 ps-1">
                <input type="checkbox" className="form-check-input" value={msg.id} onChange={(ele) => onCheck(ele, msg.id)} />
            </div>
            <div className="pe-2 ps-1">
                <span className={`mail-star ${(msg?.labels?.find((_label) => _label.slug === 'stared') ? 'active' : '' )}`} onClick={(el) => moveHandle(el, 'stared', msg.id)} data-bs-toggle="tooltip"
                      data-bs-original-title="Star">
                    <i className="ri-star-line"></i>
                    <i className="ri-star-fill"></i>
                </span>
            </div>
            <div className="mail-avatar" onClick={onClick}>{avatarContent}</div>
            <div className="mail-item-body" onClick={onClick}>
                <div className="d-flex align-items-center justify-content-between">
                    <span className="mail-sender">{sender}</span>
                    {msg?.labels &&
                        <span className="mail-labels">
                            {msg?.labels.map((label, i) => (label.slug === 'stared' ? '' :
                                <span key={i} className="badge" style={{backgroundColor: label.color}}>{label.label}</span>))}
                        </span>
                    }
                    <span className="mail-time">{time}</span>
                </div>
                <div className="mail-subject-text">
                    <h6 className="mail-subject">{subject}</h6>
                    <p className="mail-text">{text}</p>
                </div>
            </div>
        </li>
)
};

export default MailItem;